import React, { useState } from 'react';
import { Container, Paper, Typography, TextField, Button, MenuItem, Alert, Box } from '@mui/material';
import api from '../../services/api';

const karatOptions = ['22K', '24K', '22/22K', '24/24K', '18K', 'PT95', 'WG'];

const ItemForm = ({ onSuccess, hideTitle }) => {
  const [form, setForm] = useState({ name: '', abbreviation: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!form.name || !form.abbreviation) {
      setError('Both Item Name and Abbreviation are required.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/api/items', form);
      setSuccess('Item added successfully!');
      setForm({ name: '', abbreviation: '' });
      if (onSuccess) onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add item');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth={false} disableGutters sx={{ py: 0, px: 0 }}>
      <Paper sx={{ p: 0 }}>
        {!hideTitle && (
          <Typography variant="h4" gutterBottom color="primary">
            Add Item
          </Typography>
        )}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Item Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Abbreviation"
            name="abbreviation"
            value={form.abbreviation}
            onChange={handleChange}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <Box sx={{ mt: 3 }}>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? 'Saving...' : 'Add Item'}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default ItemForm;
